import styled from "styled-components";

export const Wrapper = styled.div`
    .top-bar-row {
        margin-bottom: ${props => props.isSmall ? '5px' : '40px'};
    }
    .search-container {
        position: relative;
        width: 100%;
    }
    .search-box {
        box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);
        padding: 3px 15px;
        border-radius: 10px;
        width: 100%;
        
    }
    .icon {
        position: absolute;
        top: ${props => props.isSmall ? '18px' : '20px'};
        right: 20px;
        transform: translateY(-50%);
        cursor: pointer;
    }
    .add-desktop-button {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .sm-add-users-container {
        display: flex;
        flex-direction: row;
        justify-content: ${props => props.isSmall ? 'space-between' : 'flex-end'};
        align-items: center;
        gap: ${props => props.isSmall ? '10px' : '35px'};
        margin-top: ${props => props.isSmall ? '10px' : '0'};
        margin-bottom: ${props => props.isSmall ? '0' : '10px'};
        white-space: nowrap;
        
    
        .sm-add-users-title {
          font-size: 16px;
          font-weight: 600;
         
        }
        .sm-add-users-hr {
          width: ${props => props.isSmall ? '60%' : '85%'};
          height: 2px;
          background: black;
        }
        .sm-add-users-button {
          height: 25px;
          width: 25px;
        }
    }

    .filter-Container {
        ${props => props.isSmall ? "margin-top: 20px;" : ""}
        margin-bottom: 20px;

        .filter-colapeser {
            background: #131f28;
            padding: 10px;
            border-radius: 5px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title {
                display: flex;
                align-items: center;
                gap: 10px;
                span {
                    font-size: ${props => props.isSmall ? '14px' : '16px'};
                    color: white;
                }
            }
        }

        .filter-content {
            padding: 10px;
            margin-top: 10px;
        
            .clear-button-container {
                display: flex;
                flex-direction: row;
                justify-content: flex-end;

                .clear-filter-btn {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    gap: 10px;
                    border: none;
                    background: #860707;
                    color: white;
                    border-radius: 5px;
                    padding: 5px 10px;
                }
            }

            .filter-content-container {
                .card-box {
                    box-shadow: 0 0 9px #c6c6c6;
                    padding: 15px;
                    border-radius: 5px;
                    ${props => props.isSmall ? "" : "height: 100%;"}
                }
                .mag-t {
                    margin-top: 30px;
                }
                .fiter-box {
                    .title {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        gap: 10px;

                        .text {
                            font-size: 14px;
                            font-weight: bold;
                            color: #131f28;
                            min-width: 90px;
                        }
                        .hr-line {
                            width: 100%;
                            height: 2px;
                            background: #131f28;
                        }
                    }
                    .title-advance {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: baseline;
                        gap: 10px;

                        .text {
                            font-size: 14px;
                            font-weight: bold;
                            color: #131f28;
                            min-width: 90px;
                        }
                        .hr-line-advance {
                            width: 100%;
                            height: 2px;
                            background: #131f28;
                            position: relative;
                            &:before {
                                content: "";
                                position: absolute;
                                width: 200px;
                                height: 10px;
                                padding: 2px;
                                background: rgb(19, 31, 40);
                                right: 0;
                                top: -8px;
                                border-top-left-radius: 15px;
                            }
                        }
                    }
                    .content {
                        margin-top: 8px;
                        max-height: 200px;
                        overflow: auto;

                        .options {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            border-bottom: 1px solid #ccc;
                            margin-top: 5px;
                            width: 99%;

                            .option-name {
                                font-size: 13px;
                                color: #706d6d;
                            }
                            .option-checkbox {

                            }
                        }
                    }
                    .content-advance {
                        .calender-options {
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            align-items: center;
                            
                            .month {
                                font-size: 16px;
                                font-weight: 600;
                            }
                            .calender-options-disabled {
                                color: #ccc;
                                pointer-events: none;
                                cursor: not-allowed;
                            }
                        }
                        .date-selected {
                            margin: 10px 0;
                        }
                        .sync-filter {
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-start;
                            align-items: center;

                            .sync-filter-option {
                                border-bottom: 1px solid black;
                                width: 90px;
                                padding: 10px;
                                text-align: left;
                                cursor: pointer;
                            }
                            .sync-filter-option-active {
                                border-bottom: 2px solid #e3b865;
                                width: 90px;
                                padding: 10px;
                                font-weight: 600;
                                text-align: left;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
        }
    }

    .small-screen-sorter {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        img {
            cursor pointer;
        }
    }

    @media only screen and (max-width: 1200px) {
        .filter-Container .filter-content .filter-content-container .fiter-box .title-advance .hr-line-advance:before {
            width: 100px;
        }
        .filter-Container .filter-content .filter-content-container .fiter-box .content-advance .sync-filter .sync-filter-option {
            width: 80px;
            font-size: 12px;
        }
        .filter-Container .filter-content .filter-content-container .fiter-box .content-advance .sync-filter .sync-filter-option-active {
            width: 80px;
            font-size: 12px;
        }
    }

    @media only screen and (max-width: 991px) {
        .filter-Container .filter-content .filter-content-container .fiter-box .title-advance .hr-line-advance:before {
            width: 200px;
        }
    }
    @media only screen and (max-width: 500px) {
        .filter-Container .filter-content .filter-content-container .fiter-box .title-advance .hr-line-advance:before {
            width: 100px;
        }
    }
    

    /***** ANT DESIGN STYLING *****/
    .ant-picker-calendar-mini {
        background: #f0f2f5;
        .ant-picker-body {
            background: #f0f2f5;
            padding: ${props => props.isSmall ? "5px 20px" : "5px 30px"};
        }
    }
    .ant-checkbox-checked .ant-checkbox-inner {
        background-color: #131f28;
        border-color: #131f28;  
    }
    .ant-table-tbody{
        background: #f1f1f1;
    }
    .ant-select-selector {
        border: 1px solid #131f28 !important;
        background-color: #131f28 !important;
        color: #fff !important;
    }
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
        border-color: #131f28 !important;
    }
    .ant-select-selector .ant-select-selection-placeholder {
        color: #fff !important;
    }
    .ant-select-multiple .ant-select-selection-item {
        color: black;
    }
    .ant-select-arrow {
        color: white;
    }
    .ant-select-show-search.ant-select:not(.ant-select-customize-input) .ant-select-selector {
        color: white !important;
    }
    .ant-radio-button-wrapper {
        padding: 5px 30px;
        color: #fff;
        height: 40px;
        background: #131f28 !important;
        font-size: 16px;
    }
    .ant-radio-button-wrapper:hover {
        background-color: #fff;
    }
    .ant-radio-button-wrapper-checked {
        background-color: #fff;
        color: #131f28;
        z-index: 0;
        border-color: #131f28;
    }
    .ant-radio-button:focus {
        box-shadow: none !important;
    }
    .ant-radio-button-wrapper:first-child {
        border-radius: 5px 0px 0px 5px;
    }
    .ant-radio-button-wrapper:last-child {
        border-radius: 0px 5px 5px 0px;
    }
    @media only screen and (max-width: 600px) {
        .ant-radio-button-wrapper {
            padding: 5px 15px;
        }
    }
    @media only screen and (max-width: 450px) {
        .ant-radio-button-wrapper {
            padding: 5px 10px;
        }
    }
    .ant-picker {
        width: 100%;
    }
`;
